<template>
	<div>
		<FallBack :message="message" :border="false" iconStyle="far" icon="at" />
		<div class="modal-button-container">
			<BaseButton color="blue" width="280" @onClick="handleContinue"
				>Continue</BaseButton
			>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/global/BaseButton.vue';
import FallBack from '@/components/global/FallBack.vue';

export default {
	name: 'EmailSent',
	props: {
		message: String,
	},
	components: {
		BaseButton,
		FallBack,
	},
	methods: {
		handleContinue() {
			this.$emit('continue');
		},
	},
};
</script>

<style lang="scss" scoped>
.modal-button-container {
	display: flex;
	justify-content: center;
	@include rem(padding, 10px);
	border-top: 1px solid $border-color-light;

	button {
		@include rem(max-width, 220px);
	}
}
</style>
